const toCamelCase = (text: string) => {
    let camelCaseText = "";
    if (text) {
        if (text.indexOf("_") > -1) {
            const splited = text.split("_");
            let parts: string[] = [];
            splited.forEach((part) => {
                const splited = part.split("");
                splited[0] = splited[0].toUpperCase();
                parts = [...parts, ...splited];
            });

            camelCaseText = parts.join("");
        } else {
            const splited = text.split("");
            splited[0] = splited[0].toUpperCase();
            camelCaseText = splited.join("");
        }
    }

    return camelCaseText.replace("İ", "I");
}

const toQueryStr = (obj: any | null | undefined) => {
    if (obj) {
        const str: string[] = [];
        Object.keys(obj).forEach(function (key) {
            if (key && (obj[key] || obj[key] === 0)) {
                str.push(`${key}=${encodeURIComponent(obj[key])}`);
            }
        })

        return `?${str.join("&")}`;
    }
    return ""
}

const toQueryStrWithPagination = (page: number, pageSize: number, obj: any | null | undefined) => {
    const str: string[] = [];
    str.push(`page=${page}`)
    str.push(`pageSize=${pageSize}`)
    if (obj) {
        Object.keys(obj).forEach(function (key) {
            if (key && (obj[key] || obj[key] === 0)) {
                str.push(`${key}=${encodeURIComponent(obj[key])}`);
            }
        })
    }
    return `?${str.join("&")}`;
}

const checkIfMailAddressesValid = (mailAddresses: string) => {
    let foundMismatch = false;
    const regex = /^[a-zA-Z_0-9.-]+@[a-zA-Z_0-9.-]+?\.[a-zA-Z]{2,3}$/;
    if (mailAddresses.indexOf(";") > -1) {
        const mailAddressesList = mailAddresses.split(";");
        mailAddressesList.forEach(function (mailAddress) {
            if (!mailAddress.match(regex)) {
                foundMismatch = true;
            }
        });
    }
    else if (mailAddresses.indexOf(",") > -1) {
        const mailAddressesList = mailAddresses.split(",");
        mailAddressesList.forEach(function (mailAddress) {
            if (!mailAddress.match(regex)) {
                foundMismatch = true;
            }
        });
    }
    else {
        if (!mailAddresses.match(regex)) {
            foundMismatch = true;
        }
    }

    return !foundMismatch;
}

const checkIfValidPassword = (password: string) => {
    if (password) {
        if (password.length < 8) {
            return "PasswordMustBeGreaterThan8Chars";
        }
        if (password.length > 16) {
            return "PasswordMustBeLowerThan16Chars";
        }
        if (!password.match("(?=.*?[a-z])")) {
            return "PasswordMustContainOneLowercaseLetter";
        }
        if (!password.match("(?=.*?[A-Z])")) {
            return "PasswordMustContainOneUppercaseLetter";
        }
        if (!password.match("(?=.*?[0-9])")) {
            return "PasswordMustContainOneNumber";
        }
        if (!password.match("(?=.*?[#?!@$%^&*-.,;])")) {
            return "PasswordMustContainOneSpecialChar";
        }

        return "";
    }

    return "PasswordCannotBeEmpty";
}

export { toCamelCase, toQueryStr, toQueryStrWithPagination, checkIfMailAddressesValid, checkIfValidPassword }